import type { ThemeDefinition } from './types';

const themeRegistry = new Map<string, ThemeDefinition>();

export function registerTheme(theme: ThemeDefinition): void {
  themeRegistry.set(theme.id, theme);
}

export function getTheme(id: string): ThemeDefinition | undefined {
  return themeRegistry.get(id);
}

export function getAllThemeIds(): string[] {
  return Array.from(themeRegistry.keys());
}
